"use strict";
// import { object } from '@storybook/addon-knobs';
Object.defineProperty(exports, "__esModule", { value: true });
// import {func} from 'prop-types';
var formatFunctions_1 = require("./formatFunctions");
var schemaMethods_1 = require("./schemaMethods");
var ValidationResult_1 = require("./ValidationResult");
var CompareResult_1 = require("./CompareResult");
var generateGuid_1 = require("./methods/generateGuid");
function recursiveDeepCopy(o) {
    var newO;
    var i;
    if (typeof o !== 'object') {
        return o;
    }
    if (!o) {
        return o;
    }
    if ('[object Array]' === Object.prototype.toString.apply(o)) {
        newO = [];
        for (i = 0; i < o.length; i += 1) {
            newO[i] = recursiveDeepCopy(o[i]);
        }
        return newO;
    }
    newO = {};
    for (i in o) {
        if (o.hasOwnProperty(i)) {
            newO[i] = recursiveDeepCopy(o[i]);
        }
    }
    return newO;
}
function _mergeProps(dst, src) {
    // let result = Object.assign({},dst);
    for (var key in src) {
        if (src.hasOwnProperty(key)) {
            var element = src[key];
            var dstelem = dst[key];
            if (dstelem !== undefined) {
                if (element === undefined || element === null) {
                    // if (element === undefined || (typeof dstelem === 'object' && element === null)) {
                    delete dst[key];
                }
                else {
                    if (element !== null && typeof element === 'object') {
                        _mergeProps(dst[key], element);
                    }
                    else {
                        dst[key] = recursiveDeepCopy(element);
                    }
                }
            }
            else {
                dst[key] = recursiveDeepCopy(element);
            }
        }
    }
}
function jsonMerge(jsonlist) {
    // const result = Object.assign({}, jsonlist[0]);
    var result = recursiveDeepCopy(jsonlist[0]);
    for (var i = 1; i < jsonlist.length; i++) {
        _mergeProps(result, jsonlist[i]);
    }
    return result;
}
exports.jsonMerge = jsonMerge;
/**
 * Domyślna wartośc na podstawie pól default ze schematu
 * @param schema schemat
 * @param force czy wymusić domyślne wartości dla kazdego pola:
 *  * liczba: `0`
 *  * boolean: `false`
 *  * string: `""`
 *
 */
function defaultValue(schema, force, defaultNumber) {
    if (force === void 0) { force = false; }
    if (defaultNumber === void 0) { defaultNumber = null; }
    var result = null;
    if (schema.type === 'object') {
        if (schema.default !== undefined) {
            if (schema.default === null) {
                return null;
            }
            else {
                return Object.assign({}, schema.default);
            }
        }
        result = {};
        var isEmpty = true;
        if (schema.properties) {
            for (var key in schema.properties) {
                if (schema.properties.hasOwnProperty(key)) {
                    var element = schema.properties[key];
                    var value = defaultValue(element, force, defaultNumber);
                    if (value !== undefined) {
                        result[key] = value;
                        isEmpty = false;
                    }
                }
            }
        }
        if (!isEmpty || schema.$parent === undefined || force) {
            return result;
        }
    }
    else if (schema.type === 'array') {
        var minLength = 0;
        // let minLength = schema.minItems
        if (schema.default !== undefined) {
            if (typeof schema.default === 'number') {
                minLength = schema.default;
            }
            else {
                return Array.from(schema.default);
            }
        }
        if ((schema.length !== undefined) && (typeof schema.length === 'number')) {
            minLength = schema.length;
        }
        result = [];
        var isEmpty = true;
        if (schema.items) {
            if (minLength) {
                for (var i = 0; i < minLength; i++) {
                    var value = defaultValue(schema.items, force, defaultNumber);
                    result.push(value);
                    isEmpty = false;
                }
            }
            else {
                /*
                                        const value = defaultValue(schema.items, force);
                                        if (value !== undefined) {
                                            result.push(value);
                                            isEmpty = false;
                                        }
                                        */
            }
        }
        // if (!isEmpty) return result;
        if (!isEmpty || schema.$parent === undefined || force) {
            return result;
        }
    }
    if (schema.default !== undefined) {
        return schema.default;
    }
    if (force) {
        switch (schema.type) {
            case 'number':
            case 'money':
            case 'integer':
                return defaultNumber;
            case 'boolean':
                return false;
            case 'string':
                switch (schema.format) {
                    case 'guid':
                        return generateGuid_1.default();
                    default:
                        return '';
                }
        }
    }
    // return result;
}
exports.defaultValue = defaultValue;
function validateTable(schema, data, path, exitOnFirstError) {
    if (path === void 0) { path = ''; }
    if (exitOnFirstError === void 0) { exitOnFirstError = true; }
    var result = [];
    if (schema.minLength !== undefined) {
        if (data.length < schema.minLength) {
            var err = {
                validation: 'minLength',
                expected: schema.minLength,
                value: data.length,
                path: path
            };
            if (exitOnFirstError) {
                return err;
            }
            result.push(err);
        }
    }
    if (schema.maxLength !== undefined) {
        if (data.length > schema.maxLength) {
            var err = {
                validation: 'maxLength',
                expected: schema.maxLength,
                value: data.length,
                path: path
            };
            if (exitOnFirstError) {
                return err;
            }
            result.push(err);
        }
    }
    return exitOnFirstError ? null : result;
}
exports.validateTable = validateTable;
function validateField(schema, data, path, exitOnFirstError) {
    if (path === void 0) { path = ''; }
    if (exitOnFirstError === void 0) { exitOnFirstError = true; }
    var schemaIsNumber = false;
    var dataIsNumber = false;
    var result = [];
    // console.log(JSON.stringify(schema));
    if (schema.type === 'number' || schema.type === 'money') {
        schemaIsNumber = true;
        if (typeof data !== 'number') {
            // result.valid = false;
            var err = {
                validation: 'type',
                expected: schema.type,
                value: typeof data,
                path: path
            };
            if (exitOnFirstError) {
                return err;
            }
            result.push(err);
        }
        else {
            dataIsNumber = true;
        }
    }
    else if (schema.type === 'int' || schema.type === 'integer') {
        schemaIsNumber = true;
        if (typeof data !== 'number') {
            // result.valid = false;
            var err = {
                validation: 'type',
                expected: schema.type,
                value: typeof data,
                path: path
            };
            if (exitOnFirstError) {
                return err;
            }
            result.push(err);
        }
        else {
            if (data % 1 !== 0) {
                // result.valid = false;
                var err = {
                    validation: 'type',
                    expected: schema.type,
                    value: 'float',
                    path: path
                };
                if (exitOnFirstError) {
                    return err;
                }
                result.push(err);
            }
            else {
                dataIsNumber = true;
            }
        }
    }
    if (schemaIsNumber) {
        if (dataIsNumber) {
            if (schema.maximum !== undefined) {
                if (data > schema.maximum) {
                    var err = {
                        validation: 'maximum',
                        expected: schema.maximum,
                        value: data,
                        path: path
                    };
                    if (exitOnFirstError) {
                        return err;
                    }
                    result.push(err);
                }
            }
            if (schema.exclusiveMaximum !== undefined) {
                if (data >= schema.exclusiveMaximum) {
                    var err = {
                        validation: 'exclusiveMaximum',
                        expected: schema.maximum,
                        value: data,
                        path: path
                    };
                    if (exitOnFirstError) {
                        return err;
                    }
                    result.push(err);
                }
            }
            if (schema.minimum !== undefined) {
                if (data < schema.minimum) {
                    var err = {
                        validation: 'minimum',
                        expected: schema.minimum,
                        value: data,
                        path: path
                    };
                    if (exitOnFirstError) {
                        return err;
                    }
                    result.push(err);
                }
            }
            if (schema.exclusiveMinimum !== undefined) {
                if (data <= schema.exclusiveMinimum) {
                    var err = {
                        validation: 'exclusiveMinimum',
                        expected: schema.minimum,
                        value: data,
                        path: path
                    };
                    if (exitOnFirstError) {
                        return err;
                    }
                    result.push(err);
                }
            }
            // multipleOf
            if (schema.multipleOf !== undefined) {
                if (data % schema.multipleOf !== 0) {
                    var err = {
                        validation: 'multipleOf',
                        expected: schema.multipleOf,
                        value: data,
                        path: path
                    };
                    if (exitOnFirstError) {
                        return err;
                    }
                    result.push(err);
                }
            }
        }
    }
    else {
        if (schema.type === 'string') {
            if (typeof data !== 'string') {
                var err = {
                    validation: 'type',
                    expected: schema.type,
                    value: typeof data,
                    path: path
                };
                if (exitOnFirstError) {
                    return err;
                }
                result.push(err);
            }
            else {
                if (schema.maxLength !== undefined) {
                    var l = data.length;
                    if (l > schema.maxLength) {
                        var err = {
                            validation: 'maxLength',
                            expected: schema.maxLength,
                            value: l,
                            path: path
                        };
                        if (exitOnFirstError) {
                            return err;
                        }
                        result.push(err);
                    }
                }
                if (schema.minLength !== undefined) {
                    var l = data.length;
                    if (l < schema.minLength) {
                        var err = {
                            validation: 'minLength',
                            expected: schema.minLength,
                            value: l,
                            path: path
                        };
                        if (exitOnFirstError) {
                            return err;
                        }
                        result.push(err);
                    }
                }
                // pattern
                if (schema.format !== undefined && data) {
                    var ok = formatFunctions_1.checkFormat(schema.format, data);
                    if (!ok) {
                        var err = {
                            validation: 'format',
                            expected: schema.format,
                            value: data,
                            path: path
                        };
                        if (exitOnFirstError) {
                            return err;
                        }
                        result.push(err);
                    }
                }
            }
        }
    }
    return exitOnFirstError ? null : result;
}
exports.validateField = validateField;
function _validate(schema, data, path, exitOnFirstError, result) {
    if (schema.type === 'object') {
        var required = schema.required || [];
        if (schema.properties) {
            for (var key in schema.properties) {
                // for (let key of schema.$keys) {
                if (schema.properties.hasOwnProperty(key)) {
                    var element = schema.properties[key];
                    var value = data[key];
                    if (required.indexOf(key) > -1) {
                        if (value === undefined
                            || (element.type === 'string' && !value)
                            || (element.type === 'integer' && !value)) {
                            // result.valid = false;
                            result.errors.push({
                                validation: 'required',
                                path: path === '' ? key : path + '.' + key
                            });
                            if (exitOnFirstError) {
                                continue;
                            }
                        }
                    }
                    if (value !== undefined) {
                        _validate(element, value, path === '' ? key : path + '.' + key, exitOnFirstError, result);
                    }
                }
            }
        }
    }
    else if (schema.type === 'array') {
        if (exitOnFirstError) {
            var err = validateTable(schema, data, path, true);
            if (err) {
                result.errors.push(err);
            }
        }
        else {
            var errs = validateTable(schema, data, path, false);
            if (errs.length) {
                result.errors = result.errors.concat(errs);
            }
        }
        // uniqueItems
        // contains
        var items = schema.items;
        if (items) {
            for (var i = 0; i < data.length; i++) {
                var res = _validate(items, data[i], path + '[' + i + ']', exitOnFirstError, result);
            }
        }
    }
    else {
        if (exitOnFirstError) {
            var err = validateField(schema, data, path, true);
            if (err) {
                result.errors.push(err);
            }
        }
        else {
            var errs = validateField(schema, data, path, false);
            if (errs.length > 0) {
                result.errors = result.errors.concat(errs);
            }
        }
    }
}
/**
 * Sprawdza poprawnoc danych według schematu i zawartej w nim walidacji
 * @param data dane do sprawdzenia
 * @param schema gałąź schamtu, gdy pominięto to uzywa glownej
 * @param path sciezka startowa pola, przy pominięciu ustawia pustą
 */
function validate(schema, data, exitOnFirstError, path) {
    if (exitOnFirstError === void 0) { exitOnFirstError = true; }
    if (path === void 0) { path = ''; }
    var result = new ValidationResult_1.default();
    _validate(schema, data, path || '', exitOnFirstError, result);
    if (result.errors.length) {
        result.valid = false;
    }
    return result;
}
exports.validate = validate;
function _schpath(obj) {
    if (obj.$parent === null) {
        if (obj.$key) {
            return obj.$key;
        }
        else {
            return '';
        }
    }
    else {
        var res = _schpath(obj.$parent);
        if (res === '') {
            return obj.$key;
        }
        else {
            return res + '.' + obj.$key;
        }
    }
}
var dynamicNumberRules = ['maxLength', 'minLength', 'maxItems', 'minItems', 'minimum', 'maximum', 'exclusiveMaximum', 'exclusiveMinimum'];
function _resError(type, res) {
    if (type === 'number' || type === 'money' || type === 'integer') {
        if (isNaN(res)) {
            return 'isNan';
        }
        else if (typeof res !== 'number') {
            return 'notNumber: ' + (typeof res);
        }
    }
    else if (type === 'string') {
        // nothing
    }
    else if (type === 'array') {
        if (!Array.isArray(res)) {
            return 'notArray: ' + (typeof res);
        }
    }
    else if (type === 'object') {
        if (typeof res !== 'object') {
            return 'notObject: ' + typeof res;
        }
    }
    return '';
}
function _validateSchema(schema, data, parent, key, $external, result) {
    var obj = {};
    obj.$key = key;
    obj.$model = data;
    obj.$parent = parent;
    if (parent === null) {
        obj.$root = obj;
    }
    else {
        obj.$root = parent.$root;
    }
    if (data === undefined) {
        data = defaultValue(schema, true, 0);
    }
    var paramData = [obj.$root.$model, {}, {}, {}, $external, schemaMethods_1.default, obj];
    if (parent) {
        paramData[1] = parent.$model;
        if (parent.parent) {
            paramData[2] = parent.parent.$model;
            if (parent.parent.parent) {
                paramData[3] = parent.parent.parent.$model;
            }
        }
    }
    if (schema.type === 'object') {
        for (var key2 in schema.properties) {
            var value = data[key2];
            _validateSchema(schema.properties[key2], value, obj, key2, $external, result);
        }
    }
    else if (schema.type === 'array') {
        if (Array.isArray(data)) {
            _validateSchema(schema.items, data[0], obj, 0, $external, result);
        }
    }
    // `$root,$parent,$parent2,$parent3,$external,$methods,$obj`;
    if (schema.aggregate) {
        var func = aggregateFunction(schema, false);
        try {
            var aggresult = func.apply(parent.$model, paramData);
            if (isNaN(aggresult)) {
                result.push({
                    path: _schpath(obj),
                    err: 'isNaN',
                    method: 'aggregate'
                });
            }
        }
        catch (err) {
            result.push({
                path: _schpath(obj),
                err: err,
                method: 'aggreagate'
            });
        }
    }
    if (schema.calc) {
        var func = calcFunction(schema, false);
        try {
            var aggresult = func.apply(parent.$model, paramData);
            var typerr = _resError(schema.type, aggresult);
            if (typerr) {
                result.push({
                    path: _schpath(obj),
                    err: typerr,
                    method: 'calc'
                });
            }
        }
        catch (err) {
            result.push({
                path: _schpath(obj),
                err: err,
                method: 'calc'
            });
        }
    }
    for (var i = 0; i < dynamicNumberRules.length; i++) {
        var field = dynamicNumberRules[i];
        if (schema[field] !== undefined) {
            if (typeof schema[field] !== 'number') {
                var func = validCalcFunction(schema[field]);
                try {
                    var validres = func.apply(parent.$model, paramData);
                    var typerr = _resError('number', validres);
                    if (typerr) {
                        result.push({
                            path: _schpath(obj),
                            err: typerr,
                            method: field
                        });
                    }
                }
                catch (err) {
                    result.push({
                        path: _schpath(obj),
                        err: err,
                        method: field
                    });
                }
            }
        }
    }
    if (schema.fieldRequired) {
        if (typeof schema.fieldRequired !== 'boolean') {
            var func = validCalcFunction(schema.fieldRequired);
            try {
                var validres = func.apply(parent, paramData);
                var typerr = _resError('boolean', validres);
                if (typerr) {
                    result.push({
                        path: _schpath(obj),
                        err: typerr,
                        method: 'fieldRequired'
                    });
                }
            }
            catch (err) {
                result.push({
                    path: _schpath(obj),
                    err: err,
                    method: 'fieldRequired'
                });
            }
        }
    }
    if (schema.validFunc) {
        var func = validFunction(schema, false);
        try {
            var aggresult = func.apply(parent.$model, paramData);
            if ((aggresult !== null) && (typeof aggresult !== 'boolean')) {
                var typerr = _resError('string', aggresult);
                if (typerr) {
                    result.push({
                        path: _schpath(obj),
                        err: typerr,
                        method: 'validFunction'
                    });
                }
            }
        }
        catch (err) {
            result.push({
                path: _schpath(obj),
                err: err,
                method: 'validFunc'
            });
        }
    }
}
function validateSchema(schema, path, data, $external) {
    var schema2 = schema;
    if (schema.$parent === undefined) {
        schema2 = fixAndMergeSchema([schema]);
    }
    if (path) {
        var schema3 = schemaValue(schema2, path);
        if (schema3 !== null) {
            schema2 = schema3;
        }
        else {
            throw new Error('Invalid schema path');
        }
    }
    if ($external === undefined) {
        $external = {};
    }
    if (data === undefined) {
        data = defaultValue(schema2, true, 0);
    }
    var result = [];
    _validateSchema(schema2, data, null, null, $external, result);
    return result;
}
exports.validateSchema = validateSchema;
function checkType(schema, value) {
    if (value === null) {
        return true;
    }
    switch (schema.type) {
        case 'object':
            return typeof value === 'object';
        case 'array':
            return Array.isArray(value);
        case 'integer':
        case 'number':
        case 'money':
            if (typeof value !== 'number') {
                return false;
            }
            else if (schema.type === 'integer' && value % 1 !== 0) {
                return false;
            }
            else {
                return true;
            }
        case 'string':
            return typeof value === 'string';
        case 'boolean':
            return typeof value === 'boolean';
        default:
            return false;
    }
}
exports.checkType = checkType;
function _setDataValue(schema, parent, key, value, Vue) {
    if (checkType(schema, value)) {
        if (Vue) {
            Vue.set(parent, key, value);
            parent[key] = value;
        }
        else {
            parent[key] = value;
        }
        return true;
    }
    return false;
}
function _setDataArray(schema, destArray, value, Vue, fixArraySize) {
    var sitems = schema.items;
    if (fixArraySize) {
        while (destArray.length > value.length) {
            destArray.splice(destArray.length - 1, 1);
        }
    }
    for (var i = 0; i < value.length; i++) {
        var nitem = destArray[i];
        if (nitem === undefined) {
            nitem = defaultValue(sitems, true);
            if (i > destArray.length - 1) {
                destArray.push(nitem);
            }
            else {
                if (Vue) {
                    Vue.set(destArray, i, nitem);
                }
                else {
                    destArray[i] = nitem;
                }
            }
        }
        switch (sitems.type) {
            case 'object':
                _setDataObj(sitems, nitem, value[i]);
                break;
            case 'array':
                _setDataArray(sitems, nitem, value[i]);
                break;
            default:
                if (i > destArray.length - 1) {
                    destArray.push(value[i]);
                }
                else {
                    if (Vue) {
                        Vue.set(destArray, i, value[i]);
                    }
                    else {
                        destArray[i] = value[i];
                    }
                }
                break;
        }
    }
    return true;
}
function _setDataObj(schema, parentObject, value, Vue, fixArraySize) {
    var props = schema.properties;
    for (var key in value) {
        if (value.hasOwnProperty(key)) {
            var pschema = props[key];
            if (pschema !== undefined) {
                switch (pschema.type) {
                    case 'object':
                        var nparent = parentObject[key];
                        if (nparent === undefined) {
                            parentObject[key] = nparent = defaultValue(pschema);
                        }
                        _setDataObj(pschema, nparent, value[key], Vue, fixArraySize);
                        break;
                    case 'array':
                        var narray = parentObject[key];
                        if (narray === undefined) {
                            parentObject[key] = narray = defaultValue(pschema);
                        }
                        _setDataArray(pschema, narray, value[key], Vue, fixArraySize);
                        break;
                    default:
                        _setDataValue(pschema, parentObject, key, value[key], Vue);
                        break;
                }
            }
        }
    }
    return true;
}
function _setDataKey(schema, parent, key, value) {
    if (schema.type === 'object') {
        if (typeof value === 'object') {
            var destobj = parent[key];
            if (destobj === undefined) {
                parent[key] = destobj = defaultValue(schema, true);
            }
            var keys = Object.keys(value);
            var props = schema.properties;
            var dkeys = Object.keys(props);
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var skey = keys_1[_i];
                var dschema = props[skey];
                if (dschema !== undefined) {
                    setData(dschema, destobj, skey, value[skey]);
                }
            }
            return true;
        }
        else {
            return false;
        }
    }
    else if (schema.type === 'array') {
        if (Array.isArray(value)) {
            var destobj = parent[key];
            if (destobj === undefined) {
                parent[key] = destobj = defaultValue(schema, true);
            }
            var items = schema.items;
            for (var i = 0; i < value.length; i++) {
                setData(items, destobj, i, value[i]);
            }
            return true;
        }
        else {
            return false;
        }
    }
    else {
        switch (schema.type) {
            case 'integer':
            case 'number':
            case 'money':
                if (typeof value === 'number') {
                    parent[key] = value;
                    return true;
                }
                else {
                    return false;
                }
            case 'string':
                if (typeof value === 'string') {
                    parent[key] = value;
                    return true;
                }
                else {
                    return false;
                }
            case 'boolean':
                if (typeof value === 'boolean') {
                    parent[key] = value;
                    return true;
                }
                else {
                    return false;
                }
            default:
                return false;
        }
    }
}
function setData(schema, data, value, path, pathIndex, Vue, fixArraySize) {
    if (pathIndex === void 0) { pathIndex = 0; }
    if (path !== undefined) {
        if (typeof path === 'string') {
            path = path
                .replace(/\[/g, '.')
                .replace(/\]/g, '')
                .split('.')
                .filter(function (x) { return x; });
            pathIndex = 0;
        }
        var cpath = path[pathIndex];
        if (cpath) {
            if (schema.type === 'object') {
                var dschema = schema.properties[cpath];
                if (dschema !== undefined) {
                    if (dschema.type === 'object' || dschema.type === 'array') {
                        var data2 = data[cpath];
                        if (data2 === undefined) {
                            data2 = defaultValue(dschema, true);
                            if (Vue) {
                                Vue.set(data, cpath, data2);
                            }
                            else {
                                data[cpath] = data2;
                            }
                        }
                        return setData(dschema, data2, value, path, pathIndex + 1, Vue, fixArraySize);
                    }
                    else {
                        return _setDataValue(dschema, data, cpath, value, Vue);
                    }
                }
                else {
                    return false;
                }
            }
            else if (schema.type === 'array') {
                var dschema = schema.items;
                if (dschema !== undefined) {
                    var index = parseInt(cpath, 10);
                    var data2 = data[index];
                    if (data2 === undefined) {
                        while (data.length < index + 1) {
                            data.push(defaultValue(dschema, true));
                        }
                        // data2 = data[index];
                    }
                    if (dschema.type === 'array' || dschema.type === 'object') {
                        return setData(dschema, data[index], value, path, pathIndex + 1, Vue, fixArraySize);
                    }
                    else {
                        return _setDataValue(dschema, data, index, value, Vue);
                    }
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }
    }
    if (schema.type === 'object') {
        return _setDataObj(schema, data, value, Vue, fixArraySize);
    }
    else {
        return _setDataArray(schema, data, value, Vue, fixArraySize);
    }
}
exports.setData = setData;
function clearData(schema, data, checkDataType) {
    if (schema.computed) {
        return undefined;
    }
    if (schema.type === 'object') {
        if (typeof data !== 'object') {
            return undefined;
        }
        var result = {};
        var props = schema.properties;
        if (props) {
            for (var key in props) {
                if (props.hasOwnProperty(key)) {
                    var value = data[key];
                    var element = props[key];
                    if (value !== undefined) {
                        var nvalue = clearData(value, element, checkDataType);
                        if (nvalue !== undefined) {
                            result[key] = nvalue;
                        }
                    }
                }
            }
        }
        return result;
    }
    else if (schema.type === 'array') {
        if (Array.isArray(data)) {
            var result = [];
            var items = schema.items;
            for (var i = 0; i < data.length; i++) {
                var nvalue = clearData(data[i], items, checkDataType);
                if (nvalue !== undefined) {
                    result.push(nvalue);
                }
            }
            return result;
        }
        else {
            return undefined;
        }
    }
    else {
        // na razie nie sprawdzamy typów danych
        if (Array.isArray(data)) {
            return undefined;
        }
        if (typeof data === 'object') {
            return undefined;
        }
        if (checkDataType && !checkType(schema, data)) {
            return undefined;
        }
        return data;
    }
}
exports.clearData = clearData;
function _compareData(schema, firstItem, secondItem, path, result, compareArraySize) {
    if (schema.type === 'object') {
        if (typeof firstItem !== 'object') {
            firstItem = {};
        }
        if (typeof secondItem !== 'object') {
            secondItem = {};
        }
        if (schema.properties) {
            for (var key in schema.properties) {
                if (schema.properties.hasOwnProperty(key)) {
                    var element = schema.properties[key];
                    var value1 = firstItem[key];
                    var value2 = secondItem[key];
                    _compareData(element, value1, value2, path === '' ? key : path + '.' + key, result, compareArraySize);
                }
            }
        }
    }
    else if (schema.type === 'array') {
        var items = schema.items;
        if (items) {
            if (!Array.isArray(firstItem)) {
                firstItem = [];
            }
            if (!Array.isArray(secondItem)) {
                secondItem = [];
            }
            // if (Array.isArray(firstItem) && Array.isArray(secondItem)) {
            if (firstItem.length !== secondItem.length && compareArraySize) {
                result.equal = false;
                result.diff.push({
                    path: path,
                    type: 'arrayLength',
                    value: [firstItem.length, secondItem.length],
                    schema: schema
                });
            }
            var mlength = Math.max(firstItem.length, secondItem.length);
            for (var i = 0; i < mlength; i++) {
                _compareData(items, firstItem[i], secondItem[i], path + '[' + i + ']', result, compareArraySize);
            }
        }
        // }
    }
    else {
        if (firstItem === undefined && secondItem === undefined) {
            return;
        }
        if (firstItem === undefined || secondItem === undefined) {
            result.equal = false;
            result.diff.push({
                path: path,
                type: 'value',
                value: [firstItem, secondItem],
                schema: schema
            });
            return;
        }
        if ('' + firstItem !== '' + secondItem) {
            result.equal = false;
            result.diff.push({
                path: path,
                type: 'value',
                value: [firstItem, secondItem],
                schema: schema
            });
            return;
        }
    }
}
/**
 * Porównuje dane uzywając schematu, zwraca CompareResult zawierający wynik porównania i listę róźnic
 * @param firstItem pierwszy element do porównania
 * @param secondItem drugi element do porównania
 */
function compareData(schema, firstItem, secondItem, compareArraySize) {
    var result = new CompareResult_1.default();
    _compareData(schema, firstItem, secondItem, '', result, compareArraySize);
    return result;
}
exports.compareData = compareData;
function fixData(schema, data, Vue) {
    var result = 0;
    if (schema.type === 'object') {
        var props = schema.properties;
        for (var key in schema.properties) {
            if (props.hasOwnProperty(key)) {
                var pschema = props[key];
                if (data[key] === undefined) {
                    _setDataValue(pschema, data, key, defaultValue(pschema, true), Vue);
                    result++;
                }
                else if (data[key] === null && (pschema.type === 'array' || pschema.type === 'object')) {
                    _setDataValue(pschema, data, key, defaultValue(pschema, true), Vue);
                    result++;
                }
                else {
                    result += fixData(pschema, data[key], Vue);
                }
            }
        }
    }
    else if (schema.type === 'array') {
        var pschema = schema.items;
        for (var i = 0; i < data.length; i++) {
            var value = data[i];
            result += fixData(pschema, value, Vue);
        }
    }
    return result;
}
exports.fixData = fixData;
function getRef(parent, url, root) {
    // currentContext = currentContext || this.schema;
    var turl = url.split('/');
    if (url.startsWith('#/')) {
        if (root === undefined) {
            // szukaj łażąc po parentach
            while (parent.$parent) {
                parent = parent.$parent;
            }
        }
        else {
            parent = root;
        }
    }
    else {
        // coś tam innego
    }
    // let turl = url.split("/");
    var sparent2;
    for (var i = 1; i < turl.length; i++) {
        sparent2 = parent;
        parent = parent[turl[i]];
        if (parent === undefined) {
            return null;
        }
    }
    return parent;
}
exports.fixSchemaDefaultOptions = {
    arrayItemGuidField: null
};
function fixAndMergeSchema(schemas, options, parent, root, mykey, fixType) {
    if (options === void 0) { options = exports.fixSchemaDefaultOptions; }
    var props = {};
    var result = {};
    Object.defineProperty(result, '$parent', {
        value: parent || null
    });
    if ((root === undefined) || (root === null)) {
        root = result;
    }
    var i = 0;
    while (i < schemas.length) {
        var schema = schemas[i];
        // allof
        var allOf = schema.allOf;
        if (allOf !== undefined) {
            var dschemas = [];
            // wszystkie schemas do tej pory
            for (var ii = 0; ii < i; ii++) {
                dschemas.push(schemas[ii]);
            }
            // moja schema
            dschemas.push(schema);
            // z allof
            for (var ii = 0; ii < allOf.length; ii++) {
                dschemas.push(allOf[ii]);
            }
            // wszystkie pozostałe schemas
            for (var ii = i + 1; ii < schemas.length; ii++) {
                dschemas.push(schemas[ii]);
            }
            schemas = dschemas;
            schema = schemas[i];
        }
        // $ref
        var $ref = schema.$ref;
        if ($ref !== undefined) {
            var refValue = getRef(parent, $ref, root);
            if (refValue !== null) {
                schemas[i] = schema = refValue;
            }
        }
        for (var _i = 0, _a = Object.keys(schema); _i < _a.length; _i++) {
            var key = _a[_i];
            if (key === 'allOf') {
                continue;
            }
            var keyvalue = schema[key];
            if (keyvalue === null) {
                if (i > 0) {
                    delete props[key];
                    delete result[key];
                }
                else {
                    result[key] = null;
                }
            }
            else {
                if (Array.isArray(keyvalue)) {
                    if (result[key] !== undefined) {
                        // łącz array
                        var darray = result[key].slice();
                        for (var ii = 0; ii < keyvalue.length; ii++) {
                            var avalue = keyvalue[ii];
                            if (darray.indexOf(avalue) === -1) {
                                darray.push(avalue);
                            }
                        }
                        result[key] = darray;
                    }
                    else {
                        result[key] = keyvalue;
                    }
                }
                else if (typeof keyvalue === 'object') {
                    var proparray = props[key];
                    if (proparray === undefined) {
                        props[key] = proparray = [keyvalue];
                    }
                    else {
                        proparray.push(keyvalue);
                    }
                }
                else {
                    result[key] = keyvalue;
                }
            }
        }
        i++;
    }
    if ((fixType === true) || (fixType === undefined)) {
        if (result.type === undefined) {
            if (props.properties !== undefined) {
                result.type = 'object';
            }
            else if (props.items !== undefined) {
                result.type = 'array';
            }
            else {
                result.type = 'string';
                /*

                if (!((parent) && (parent.type === 'object'))) {
                    result.type = 'string';
                }
                */
            }
        }
        else if (result.type === 'int') {
            result.type = 'integer';
        }
    }
    // fix guid field in array items
    /*
    if ((parent && parent.type === 'object') && (parent.$parent && parent.$parent.type === 'array')) {

    }
    */
    // dołaczanie wszystkich property
    // let propsCache: any = {};
    var fixChildType = (mykey !== undefined) && (mykey === 'properties');
    if (false) {
        var newprops = {};
        var keys = Object.keys(props);
        var _loop_1 = function (key) {
            var cached;
            newprops[key] = {
                enumerable: true,
                configurable: true,
                get: function () {
                    if (cached) {
                        // console.log('schema cached property', key);
                        return cached;
                    }
                    else {
                        // console.log('schema get property', key);
                        return (cached = fixAndMergeSchema(props[key], options, result, root, key, fixChildType || (key === 'items')));
                    }
                }
            };
        };
        for (var _b = 0, keys_2 = keys; _b < keys_2.length; _b++) {
            var key = keys_2[_b];
            _loop_1(key);
        }
        Object.defineProperties(result, newprops);
    }
    else {
        // const cached2: any = {};
        var keys = Object.keys(props);
        var _loop_2 = function (key) {
            var cached;
            Object.defineProperty(result, key, {
                enumerable: true,
                configurable: true,
                get: function () {
                    if (cached) {
                        // console.log('schema cached property', key);
                        return cached;
                    }
                    else {
                        // console.log('schema get property', key);
                        return (cached = fixAndMergeSchema(props[key], options, result, root, key, fixChildType || (key === 'items')));
                    }
                }
            });
        };
        for (var _c = 0, keys_3 = keys; _c < keys_3.length; _c++) {
            var key = keys_3[_c];
            _loop_2(key);
        }
    }
    if ((result.type === 'object') && ((parent) && (parent.type === 'array') && (options.arrayItemGuidField))) {
        var pp_1 = result.properties;
        if (pp_1 && pp_1[options.arrayItemGuidField] === undefined) {
            var cached_1;
            Object.defineProperty(pp_1, options.arrayItemGuidField, {
                enumerable: true,
                configurable: true,
                get: function () {
                    if (cached_1) {
                        // console.log('schema cached property', key);
                        return cached_1;
                    }
                    else {
                        // console.log('schema get property', key);
                        return (cached_1 = fixAndMergeSchema([{
                                type: 'string',
                                format: 'guid'
                            }], options, pp_1, root, options.arrayItemGuidField, false));
                    }
                }
            });
            /*
                    pp[fixSchemaOptions.arrayItemGuidField] = {
                      type: 'string',
                      format: 'guid'
                    };
                    */
        }
    }
    return result;
}
exports.fixAndMergeSchema = fixAndMergeSchema;
function _dataValue(data, path, pindex, schema) {
    var prop = path[pindex];
    if (prop === '') {
        if (pindex === path.length - 1) {
            return undefined;
        }
        else {
            return _dataValue(data, path, pindex + 1, schema);
        }
    }
    if (schema) {
        if (schema.type === 'object' && schema.properties) {
            var schitem = schema.properties[prop];
            if (schitem === undefined) {
                return undefined;
            }
            var ndata = data[prop];
            if (ndata === undefined) {
                if (schitem.default !== undefined) {
                    ndata = schitem.default;
                }
                else {
                    return undefined;
                }
            }
            if (pindex === path.length - 1) {
                return ndata;
            }
            else {
                return _dataValue(ndata, path, pindex + 1, schitem);
            }
        }
        else if (schema.type === 'array') {
            var schitem = schema.items;
            if (schitem === undefined) {
                return undefined;
            }
            var ndata = data[Number(prop)];
            if (ndata === undefined) {
                if (schitem.default !== undefined) {
                    ndata = schitem.default;
                }
                else {
                    return undefined;
                }
            }
            if (pindex === path.length - 1) {
                return ndata;
            }
            else {
                return _dataValue(ndata, path, pindex + 1, schitem);
            }
        }
        else {
            return undefined;
        }
    }
}
function dataValue(schema, data, path) {
    var tpath = path
        .replace(/\[/g, '.')
        .replace(/\]/g, '')
        .split('.');
    return _dataValue(data, tpath, 0, schema);
}
exports.dataValue = dataValue;
/*
function _setData(schema: JSONSchema, parentData: any, key: any, value: any, path: string[], pindex: number) {
  if ((path[pindex] === undefined) || (path[pindex] === '')) {
    if (schema.type === 'object') {


    } else if (schema.type === 'array') {

    } else {
      data = value;
    }
  }
}

export function setData(schema: JSONSchema, data: any, value: any, path: string) {
  const tpath = (path || '')
    .replace(/\[/g, '.')
    .replace(/\]/g, '')
    .split('.');

  return _setData(schema, data, value, tpath, 0);

}
*/
function _schemaValue(path, pindex, schema) {
    var prop = path[pindex];
    if (prop === '') {
        if (pindex === path.length - 1) {
            return null;
        }
        else {
            return _schemaValue(path, pindex + 1, schema);
        }
    }
    if (schema.type === 'object' && schema.properties) {
        var schitem = schema.properties[prop];
        if (schitem === undefined) {
            return null;
        }
        if (pindex === path.length - 1) {
            return schitem;
        }
        else {
            return _schemaValue(path, pindex + 1, schitem);
        }
    }
    else if (schema.type === 'array' && schema.items) {
        var schitem = schema.items;
        if (schitem === undefined) {
            return null;
        }
        if (pindex === path.length - 1) {
            return schitem;
        }
        else {
            return _schemaValue(path, pindex + 1, schitem);
        }
    }
    else {
        return null;
    }
}
/**
 * Zwraca czesc schematu na podstawie sciezki
 * @param path sciezka w formacie pole.tablica[0].pole2
 */
function schemaValue(schema, path) {
    var tpath = path
        .replace(/\[/g, '.')
        .replace(/\]/g, '')
        .split('.');
    return _schemaValue(tpath, 0, schema);
}
exports.schemaValue = schemaValue;
var _validations = {
    minItems: function (value, runschema) { return (value.length >= runschema.minItems ? null : 'minItems'); },
    maxItems: function (value, runschema) { return (value.length <= runschema.maxItems ? null : 'minItems'); },
    minimum: function (value, runschema) { return (value >= runschema.minimum ? null : 'minimum'); },
    exclusiveMinimum: function (value, runschema) { return (value > runschema.exclusiveMinimum ? null : 'exclusiveMinimum'); },
    maximum: function (value, runschema) { return (value <= runschema.maximum ? null : 'maximum'); },
    exclusiveMaximum: function (value, runschema) { return (value < runschema.exclusiveMaximum ? null : 'exclusiveMaximum'); },
    enum: function (value, runschema) { return (runschema.enum.indexOf(value) > -1 ? null : 'enum'); },
    multipleOf: function (value, runschema) { return (value % runschema.multipleOf === 0 ? null : 'multipleOf'); },
    maxLength: function (value, runschema) { return (value.length <= runschema.maxLength ? null : 'maxLength'); },
    minLength: function (value, runschema) { return (value.length >= runschema.minLength ? null : 'minLength'); }
};
function getValidations(schema, cache) {
    var funcs = cache ? schema.validationFunctions : undefined;
    if (funcs === undefined) {
        funcs = [];
        if (schema.type === 'array') {
            if (schema.minItems !== undefined) {
                funcs.push(_validations.minItems);
            }
            if (schema.maxItems !== undefined) {
                funcs.push(_validations.maxItems);
            }
        }
        else {
            if (schema.minimum !== undefined) {
                funcs.push(_validations.minimum);
            }
            if (schema.exclusiveMinimum !== undefined) {
                // let nn: number = schema.exclusiveMinimum;
                funcs.push(_validations.exclusiveMinimum);
            }
            if (schema.maximum !== undefined) {
                funcs.push(_validations.maximum);
            }
            if (schema.exclusiveMaximum !== undefined) {
                funcs.push(_validations.exclusiveMaximum);
            }
            if (schema.enum !== undefined) {
                funcs.push(_validations.enum);
            }
            if (schema.type === 'number' || schema.type === 'integer' || schema.type === 'money') {
                if (schema.multipleOf) {
                    funcs.push(_validations.multipleOf);
                }
            }
            else if (schema.type === 'string') {
                if (schema.maxLength !== undefined) {
                    funcs.push(_validations.maxLength);
                }
                if (schema.minLength !== undefined) {
                    funcs.push(_validations.minLength);
                }
                if (schema.pattern !== undefined) {
                    try {
                        var rg_1 = new RegExp(schema.pattern || '');
                        funcs.push(function (value, runschema) { return (rg_1.test(value) ? null : 'pattern'); });
                        // tslint:disable-next-line: no-empty
                    }
                    catch (err) {
                        funcs.push(function (value, runschema) { return 'pattern'; });
                    }
                }
                if (schema.format !== undefined) {
                    // const ff = formatFunctions[schema.format];
                    var ff_1 = formatFunctions_1.checkFormatFunction(schema.format || '');
                    // console.log('get format function', schema.format, ff);
                    if (ff_1 !== undefined) {
                        funcs.push(function (value, runschema) { return (ff_1(value) ? null : 'format'); });
                    }
                }
            }
        }
        if (cache) {
            Object.defineProperty(schema, 'validationFunctions', {
                enumerable: false,
                value: funcs
            });
        }
    }
    return funcs;
}
exports.getValidations = getValidations;
var cacheFuncs = {};
function _fix$parent(stext) {
    if (stext.indexOf('$parent') > -1) {
        return stext
            .replace(/\$parent\.\$parent\.\$parent\./g, '$parent3.')
            .replace(/\$parent\.\$parent\./g, '$parent2.')
            .replace(/\$parent\./g, '$parent.');
    }
    else {
        return stext;
    }
}
exports.funcParams = "$root,$parent,$parent2,$parent3,$external,$methods,$obj";
// funkcje
function calcFunction(schema, cache, debug) {
    if (cache === void 0) { cache = true; }
    var func = null;
    var calc = schema.calc;
    if (calc) {
        var funcText = schema.calc;
        var cacheKey = funcText;
        var when = '';
        if (calc.when) {
            funcText = calc.func;
            when = calc.when;
        }
        if (cache && !debug) {
            func = cacheFuncs['calc_' + when + '_' + funcText];
            if (func !== undefined) {
                return func;
            }
        }
        var stext = _fix$parent(funcText);
        var ftext = '';
        switch (schema.type) {
            case 'integer':
                ftext += "return $methods.mround((" + stext + "),0);";
                break;
            // case 'money': ftext += 'return Math.round($result);'; break;
            case 'money':
                ftext += "return $methods.mround((" + stext + "),2);";
                break;
            case 'number':
                if (schema.precision !== undefined) {
                    ftext += "return $methods.mround((" + stext + ")," + schema.precision + ");";
                }
                else {
                    ftext += "return (" + stext + ");";
                }
                break;
            default:
                ftext += "return (" + stext + ");";
                break;
        }
        if (when) {
            ftext = "if (" + _fix$parent(when) + ") {\r\n  " + ftext + "\r\n}";
        }
        if (debug) {
            ftext = 'console.debug($obj.$path);\r\ndebugger;\r\n' + ftext;
        }
        if (process.env.NODE_ENV !== 'production') {
            ftext = '"use strict"\r\n' + ftext;
        }
        func = new Function(exports.funcParams, ftext);
        if (cache && !debug) {
            cacheFuncs['calc_' + when + '_' + funcText] = func;
        }
    }
    return func;
}
exports.calcFunction = calcFunction;
function aggregateFunction(schema, cache, debug) {
    if (cache === void 0) { cache = true; }
    if (schema.aggregate) {
        var aggregateFunc = null;
        var cachekey = '';
        if (cache && !debug) {
            cachekey = "agg_" + schema.aggregate.func
                + ("||" + schema.aggregate.array)
                + ("||" + schema.aggregate.property)
                + ("||" + schema.aggregate.when);
            aggregateFunc = cacheFuncs[cachekey];
            if (aggregateFunc) {
                return aggregateFunc;
            }
        }
        // let aggregateFunc = cache ? schema.cache.aggregateFunc : null;
        // może być podanna jako tablica
        var arraylist = schema.aggregate.array;
        if (!Array.isArray(arraylist)) {
            arraylist = [arraylist];
        }
        var func = schema.aggregate.func || 'sum';
        var ifprop = schema.aggregate.when || schema.aggregate.if;
        if (ifprop) {
            ifprop = _fix$parent(ifprop).replace(/\$item\./g, '$array[$index].');
        }
        var prop = schema.aggregate.property;
        if (prop) {
            var complexprop = /[\$\.]/.test(prop);
            if (!complexprop) {
                prop = '$array[$index].' + prop;
            }
            else {
                prop = _fix$parent(prop).replace(/\$item\./g, '$array[$index].');
            }
        }
        else {
            prop = '$array[$index]';
        }
        var ftext = 'var $length=0;\r\n';
        // ftext += `var sttime=(new Date()).getTime();var $length=0;`;
        switch (func) {
            case 'mul':
                ftext += "var $result=1;\r\n";
                break;
            case 'min':
                if (schema.type === 'string') {
                    ftext += "var $result='\u017A\u017A\u017A\u017A\u017A\u017A\u017A\u017A\u017A\u017A\u017A\u017A';\r\n";
                }
                else {
                    ftext += "var $result=Infinity;\r\n";
                }
                break;
            case 'max':
                if (schema.type === 'string') {
                    ftext += "var $result='';\r\n";
                }
                else {
                    ftext += 'var $result=-Infinity;\r\n';
                }
                break;
            case 'map':
                ftext += "var $result=[];\r\n";
                break;
            default:
                ftext += "var $result=0;\r\n";
                break;
        }
        var ltext = '';
        switch (func) {
            case 'avg':
            case 'sum':
                ltext += "$result+=(" + prop + ")";
                break;
            case 'max':
                ltext += "var v=(" + prop + ");\r\nif (v>$result)\r\n  $result=v";
                break;
            case 'min':
                ltext += "var v=(" + prop + ");\r\nif (v<$result)\r\n  $result=v";
                break;
            case 'mul':
                ltext += "$result*=(" + prop + ")";
                break;
            case 'count':
                ltext += "$result++;";
                break;
            case 'first':
            case 'last':
                ltext += "$result=(" + prop + ");break;";
                break;
            case 'map':
                ltext += "$result.push(" + prop + ");";
                break;
        }
        if (ifprop) {
            if (func === 'first' || func === 'map') {
                // tslint:disable-next-line: max-line-length
                ltext = "var $arrayLength=$array.length;\r\nfor($index=0;$index<$arrayLength;$index++) {\r\n  if (" + ifprop + ") {\r\n    $length++;\r\n    " + ltext + "\r\n}\r\n}";
            }
            else {
                ltext = "var $index = $arrayLength = $array.length;\r\n"
                    + ("while($index--) {\r\n  if (" + ifprop + ") {\r\n    $length++;\r\n    " + ltext + "}}");
            }
            // ftext += `do {with(aaa[i]) {if (${ifprop}) {${ltext}}}} while(i--);`;
        }
        else {
            if (func === 'first' || func === 'map') {
                // tslint:disable-next-line: max-line-length
                ltext = "var $arrayLength=$array.length;\r\n$length+=$arrayLength;\r\nfor($index=0;$index<$arrayLength;$index++) {\r\n  " + ltext + "\r\n}";
            }
            else {
                ltext = "var $index = $arrayLength = $array.length;\r\n$length+=$index;\r\nwhile($index--) {\r\n  " + ltext + "\r\n}";
            }
        }
        for (var _i = 0, arraylist_1 = arraylist; _i < arraylist_1.length; _i++) {
            var arraykey = arraylist_1[_i];
            var subarray = null;
            var pp = arraykey.indexOf('/');
            if (pp > -1) {
                subarray = arraykey.substr(pp + 1);
                arraykey = arraykey.substr(0, pp);
            }
            var complexarray = /[\$\.]/.test(arraykey);
            if (!complexarray) {
                arraykey = 'this.' + arraykey;
            }
            arraykey = _fix$parent(arraykey);
            if (subarray) {
                // tslint:disable-next-line: max-line-length
                ftext += "var $parentArray = " + arraykey + ";\r\nvar $parentLength=$parentArray.length;\r\nfor($parentIndex=0;$parentIndex<$parentLength;$parentIndex++) {\r\n  var $array=$parentArray[$parentIndex]." + subarray + ";\r\n  if ($array) {\r\n    " + ltext + "\r\n}\r\n}";
            }
            else {
                ftext += "var $array = " + arraykey + ";";
                /*
                switch (func) {
                  case 'min':
                  case 'max':
                  case 'mul': ftext+="if ($result===undefined && $array.length) "
                }
                */
                ftext += ltext;
                // ltext;
            }
        }
        if (func === 'avg') {
            ftext += 'if ($length)\r\n  $result/=$length;';
        }
        switch (func) {
            case 'mul':
                ftext += "if ($length===0)\r\n  $result=0;";
                break;
            case 'min':
            case 'max':
                if (schema.type === 'string') {
                    ftext += "if ($length===0)\r\n  $result='';";
                }
                else {
                    ftext += "if ($length===0)\r\n  $result=0;";
                }
                break;
        }
        switch (schema.type) {
            case 'integer':
                ftext += '\r\nreturn $methods.mround($result,0);';
                break;
            case 'money':
                ftext += '\r\nreturn $methods.mround($result,2);';
                break;
            case 'number':
                if (schema.precision) {
                    ftext += "\r\nreturn $methods.mround($result," + schema.precision + ");";
                }
                else {
                    ftext += "\r\nreturn $result;";
                }
                break;
            default:
                ftext += "\r\nreturn $result;";
                break;
        }
        // return (schema.cache.aggregateFunc = aggregateFunc = new Function(funcParams, ftext));
        if (debug) {
            ftext = 'console.debug($obj.$path);\r\ndebugger;\r\n' + ftext;
        }
        aggregateFunc = new Function(exports.funcParams, ftext);
        if (cache && !debug) {
            cacheFuncs[cachekey] = aggregateFunc;
        }
        return aggregateFunc;
        // return (schema.cache.aggregateFunc = aggregateFunc = new Function(funcParams, ftext));
    }
}
exports.aggregateFunction = aggregateFunction;
function validFunction(schema, cache, debug) {
    if (cache === void 0) { cache = true; }
    var func = null;
    if (schema.validFunc) {
        if (cache && !debug) {
            func = cacheFuncs['valid_' + schema.validFunc];
            if (func !== undefined) {
                return func;
            }
        }
        var stext = _fix$parent(schema.validFunc);
        // let ftext = '';
        if (stext.indexOf('{') === -1) {
            stext = "{$result=(" + stext + ")}";
        }
        var ffunc = "var $value=$obj.$model;\r\nvar $result=null;\r\n" + stext + ";";
        // ffunc+=`${}`;
        // ffunc += 'with($data) {';
        // ffunc += `with(parent) ${stext};`;
        // ffunc += '};';
        // ffunc += `console.log('validFuncResult','${propName}',$result);`;
        ffunc += '\r\nreturn $result;';
        if (debug) {
            ffunc = 'console.dbug($obj.$path);\r\ndebugger;\r\n' + ffunc;
        }
        // old
        /*
        ftext += `return (${stext});`;



        if (debug && !debug) {
            ftext = 'debugger;\r\n' + ftext;
        }
        */
        func = new Function(exports.funcParams, ffunc);
        if (cache) {
            cacheFuncs['valid_' + schema.validFunc] = func;
        }
    }
    return func;
}
exports.validFunction = validFunction;
function validCalcFunction(rule, cache) {
    if (cache === void 0) { cache = true; }
    var s = '';
    if (typeof rule === 'string') {
        rule = _fix$parent(rule);
        s = "return (" + rule + ")";
    }
    else if (Array.isArray(rule)) {
        for (var i = 0; i < rule.length; i++) {
            var item = rule[i];
            var ss = item.when || item.if || '';
            ss = _fix$parent(ss);
            var ss2 = item.value;
            if (ss2 === undefined) {
                ss2 = ss;
            }
            else {
                if (typeof ss2 === 'string') {
                    ss2 = _fix$parent(ss2);
                }
            }
            s += "if (" + ss + ") return (" + ss2 + ");";
        }
    }
    // console.log('create valid function', rule, s);
    return new Function(exports.funcParams, s);
}
exports.validCalcFunction = validCalcFunction;
var reactivekey = 1000;
function _reactiveModel(schema, parent, propName, vueoptions, data) {
    if (schema.type === 'object') {
        var props = schema.properties;
        if (props !== undefined) {
            var mparent = new Object();
            parent[propName] = mparent;
            var keys = Object.keys(props);
            for (var _i = 0, keys_4 = keys; _i < keys_4.length; _i++) {
                var key = keys_4[_i];
                var element = props[key];
                _reactiveModel(element, mparent, key, vueoptions, data === undefined ? undefined : data[key]);
                /*
                if (data && data[key] !== undefined) {
                  parent[key] = data[key];
                } else {
                  parent[key] = defaultValue(element, true);
                }
                */
            }
        }
    }
    else if (schema.type === 'array') {
        // array
        var items = schema.items;
        if (items !== undefined) {
            var mparent = [];
            parent[propName] = mparent;
            if (data !== undefined) {
                for (var i = 0; i < data.length; i++) {
                    _reactiveModel(items, mparent, i, vueoptions, data[i]);
                }
            }
        }
    }
    else {
        var value_1 = null;
        if (data === undefined) {
            value_1 = defaultValue(schema, true);
        }
        else {
            value_1 = data;
        }
        parent[propName] = value_1;
        if (schema.calc || schema.aggregate) {
            // przygotuj dane `$root,$parent,$parent2,$parent3,$external,$methods,$obj`;
            // const keynumber = Math.trunc(Math.random() * 10000000);
            var keynumber = reactivekey++;
            var calcdata_1 = [
                vueoptions.data.model,
                {},
                {},
                {},
                {},
                schemaMethods_1.default,
                {} // $obj
            ];
            if (schema.aggregate) {
                var func_1 = aggregateFunction(schema, true);
                vueoptions.computed['calc_' + keynumber] = {
                    get: function () {
                        // return (parent[propName] = func.apply(parent, calcdata));
                        var res = func_1.apply(parent, calcdata_1);
                        parent[propName] = res;
                        return res;
                    }
                };
            }
            else if (schema.calc) {
                var func_2 = calcFunction(schema, true);
                vueoptions.computed['calc_' + keynumber] = {
                    // get: () => parent.a + parent.b
                    get: function () {
                        return (parent[propName] = func_2.apply(parent, calcdata_1));
                        // const res = func.apply(parent, calcdata);
                        // parent[propName] = res;
                        //  return res;
                    }
                };
            }
            vueoptions.watch['calc_' + keynumber] = function (newValue) {
                parent[propName] = value_1;
            };
        }
    }
}
exports._reactiveModel = _reactiveModel;
function reactiveModel(schema, Vue, data) {
    reactivekey = 1000;
    var vueoptions = {
        data: {
            model: {}
        },
        computed: {},
        watch: {}
    };
    var stime = new Date().getTime();
    _reactiveModel(schema, vueoptions.data, 'model', vueoptions, data);
    console.log('rtime', new Date().getTime() - stime);
    var vm = new Vue(vueoptions);
    return vm.model;
}
exports.reactiveModel = reactiveModel;
/*

    //ftext += `console.log("aggregate",(new Dat
    e()).getTime()-sttime, $result);`;
    if (func === 'avg') { ftext += 'if ($length) $result/=$length;'; }
    if (self.asyncComputed) {
        switch (schema.type) {
            case 'integer': ftext += 'resolve(Math.round($result));'; break;
            case 'money': ftext += 'resolve(this.$options.$ext.mround($result));'; break;
            default: ftext += 'resolve($result);'; break;
        }

    } else {
        switch (schema.type) {
            case 'integer': ftext += 'return Math.round($result);'; break;
            case 'money': ftext += 'return this.$options.$ext.mround($result);'; break;
            default: ftext += 'return $result;'; break;
        }
    }

    // asyncComputed
    if (self.asyncComputed) {
        ftext = `return new Promise(function(resolve,reject) {${ftext}});`;

    }


    if (ifprop) {
        console.log(`aggFunc`, ftext);
    }
    schema.cache.aggregateFunc = aggregateFunc = new Function(ftext);
}

if (self.asyncComputed) {
    if (asyncComputed === null) {
        asyncComputed = new Object();
        asyncComputed.aggregate = aggregateFunc;
    }

} else {
    computed.aggregate = aggregateFunc;
}

    }


*/
var JSchema = /** @class */ (function () {
    function JSchema(schema) {
        this.schema = {};
        // this.schema={};
        if (schema) {
            this.init(schema);
        }
    }
    /**
     * ładowanie schema
     * @param schema JSONSchema | string | JSONSchema[] | string[]
     */
    JSchema.prototype.init = function (schema) {
        var schemalist = [];
        if (Array.isArray(schema)) {
            for (var _i = 0, schema_1 = schema; _i < schema_1.length; _i++) {
                var schemaitem = schema_1[_i];
                if (typeof schemaitem === 'string') {
                    schemalist.push(JSON.parse(schemaitem));
                }
                else {
                    schemalist.push(schemaitem);
                }
            }
        }
        else if (typeof schema === 'string') {
            schemalist.push(JSON.parse(schema));
        }
        else {
            schemalist.push(schema);
        }
        this.schema = fixAndMergeSchema(schemalist);
    };
    /**
     * Domyślna wartośc na podstawie pól default ze schematu
     * @param schemaPath Ściezka schematu dla ktorej zwrocic domyslan wartosc, gdy pominieta zwraca dla pelnego schematu
     */
    JSchema.prototype.defaultValue = function (force, schemaPath) {
        var schema = schemaPath ? this.schemaValue(schemaPath) : this.schema;
        if (schema) {
            return defaultValue(schema, force);
        }
        return null;
    };
    /**
     * Zwraca wartosc pola danych wg sciezki
     * @param data Pelne dane
     * @param path sciezka w formacie pole.tablica[0].pole2
     */
    JSchema.prototype.dataValue = function (data, path) {
        return dataValue(this.schema, data, path);
    };
    /**
     * Zwraca czesc schematu na podstawie sciezki
     * @param path sciezka w formacie pole.tablica[0].pole2
     */
    JSchema.prototype.schemaValue = function (path) {
        return schemaValue(this.schema, path);
    };
    /**
     * Sprawdza poprawnoc danych według schematu i zawartej w nim walidacji
     * @param data dane do sprawdzenia
     * @param schema gałąź schamtu, gdy pominięto to uzywa glownej
     * @param path sciezka schamtu, gdy pusta uzywa glownej
     */
    JSchema.prototype.validate = function (data, exitOnFirstError, schema, path) {
        if (exitOnFirstError === void 0) { exitOnFirstError = true; }
        if (schema === void 0) { schema = null; }
        if (path === void 0) { path = ''; }
        var result = new ValidationResult_1.default();
        _validate(schema || this.schema, data, path || '', exitOnFirstError, result);
        if (result.errors.length) {
            result.valid = false;
        }
        return result;
    };
    /**
     * Porównuje dane uzywając schematu, zwraca CompareResult zawierający wynik porównania i listę róźnic
     * @param firstItem pierwszy element do porównania
     * @param secondItem drugi element do porównania
     */
    JSchema.prototype.compareData = function (firstItem, secondItem, compareArraySize) {
        return compareData(this.schema, firstItem, secondItem);
    };
    /**
     * Czyści dane pozostawiając tylko te zgodne ze schematem, nie weryfikuje prostych typów danych
     * @param data dane do wyczyszczenia
     * @param checkDataType czy sprawdzac poprawnośc typów danych prostych
     *                      (number,integer,boolean, string), domyślnie nie
     */
    JSchema.prototype.clearData = function (data, checkDataType) {
        return clearData(data, this.schema, checkDataType);
    };
    JSchema.prototype.setData = function (data, value, path, Vue) {
        return setData(this.schema, data, value, path, 0, Vue);
    };
    return JSchema;
}());
exports.default = JSchema;
//# sourceMappingURL=JSchema.js.map